import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
    selector: 'first-second-names',
    templateUrl: './first-second-names.component.html',
    styleUrls: ['./first-second-names.component.scss'],
    standalone: false
})
export class FirstSecondNamesComponent
  implements OnInit, OnChanges, AfterViewInit
{
  userOtherFirstNames: UntypedFormArray;

  @Input() submitted: boolean;

  @Input() derrors: any = false;

  constructor(
    private controlContainer: ControlContainer,
    private cd: ChangeDetectorRef,
  ) {}
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.userOtherFirstNames = this.controlContainer
      .control as UntypedFormArray;
  }

  get isRequired(): boolean {
    return !!this.userOtherFirstNames?.validator;
  }

  addFields() {
    if (this.userOtherFirstNames.valid) {
      this.userOtherFirstNames.push(
        new UntypedFormControl(''),
        // new FormGroup({
        //   firstName: new FormControl(""),
        //   // secondName: new FormControl("", [Validators.required]),
        // })
      );

      this.userOtherFirstNames.markAsUntouched();
    } else {
      this.userOtherFirstNames.markAllAsTouched();
    }
  }

  deleteFields(index) {
    this.userOtherFirstNames.removeAt(index);

    this.userOtherFirstNames.markAsDirty();
  }

  ngOnChanges() {
    if (this.userOtherFirstNames)
      this.userOtherFirstNames.controls.forEach(control => {
        control.setValidators([]);
        control.updateValueAndValidity();
      });
  }
}
